import { IUser } from 'auth/types/User';
import {
  mParticleSetUserGoatId,
  mParticleSetUserLoggedIn,
  mParticleSetUserLoggedOut,
} from 'tracking/utils/mParticleServiceMethods';

export const actions = {
  logIn: 'logIn',
  logOut: 'logOut',
  setUser: 'setUser',
};

export interface IAuthState {
  isAuthenticated: boolean;
  user: IUser | null;
}

export const INITIAL_AUTH_STATE: IAuthState = {
  isAuthenticated: false,
  user: null,
};

export const authReducer = (state: IAuthState, action) => {
  switch (action.type) {
    case actions.logIn: {
      const { user, eventContext, accountCreation } = action?.payload;
      state.isAuthenticated = true;
      state.user = user;
      mParticleSetUserLoggedIn({ user, eventContext, accountCreation });
      break;
    }
    case actions.logOut:
      state.isAuthenticated = false;
      state.user = null;
      mParticleSetUserLoggedOut();
      break;
    case actions.setUser:
      state.user = action.payload;
      mParticleSetUserGoatId({ user: action?.payload });
      break;
    default:
      return state;
  }
  return state;
};
